/**
 * Tenant sign-in method (Tenant.AuthenticationMode).
 *
 * Shared between the admin tenant-settings editor (which WRITES the value) and
 * the client startup/login flow (which READS it to decide how to authenticate).
 * The backend enum is 1 = Local (username + password form) and
 * 2 = ActiveDirectory (fetch a token directly, no form). Seed data may carry an
 * out-of-range value — treat anything that isn't ActiveDirectory as Local.
 */
export const AUTHENTICATION_MODE = {
  LOCAL: 1,
  ACTIVE_DIRECTORY: 2,
};

/** True only for the ActiveDirectory mode; every other value falls back to Local. */
export const isActiveDirectoryMode = (mode) =>
  mode === AUTHENTICATION_MODE.ACTIVE_DIRECTORY;
